import * as types from './type';

import { Property }  from  '../../services/property';

export function getProperty(data) {
    return {
      type: types.GET_PROPERTY_DETAIL,
      payload: Property.getProperty(data),
    };
};

export function updateProperty(data) {
  return {
    type: types.UPDATE_PROPERTY,
    payload: Property.updateProperty(data),
  };
};

export function getSelfProperties(data) {
  return {
    type: types.GET_SELFT_PROPERTY_LISTING,
    payload: Property.getSelfProperties(data),
  };
};

export function getRentedProperties(data) { 
  return {
    type: types.GET_RENTED_PROPERTIES,
    payload: Property.getRentedProperties(data),
  };
};

export function getPropertiesForSale(data) { 
  return {
    type: types.GET_SALE_PROPERTIES,
    payload: Property.getPropertiesForSale(data),
  };
};


export function getRelatedProperties(data) { 
  return {
    type: types.GET_RELATED_PROPERTIES,
    payload: Property.getRelatedProperties(data),
  };
};

export function getFeaturedProperties(data) { 
  return {
    type: types.GET_FEATURED_PROPERTIES,
    payload: Property.getFeaturedProperties(data),
  };
};

export function getFeaturedPropertiesWithPagination(data) { 
  return {
    type: types.GET_FEATURED_PROPERTIES_WITH_PAGINATION,
    payload: Property.getFeaturedPropertiesWithPagination(data),
  };
};

export function getLatestProperties(data) { 
  return {
    type: types.GET_LATEST_PROPERTIES_WITH_PAGINATION,
    payload: Property.getLatestProperties(data),
  };
};

export function searchProperties(data) { 
  return {
    type: types.SEARCH_PROPERTIES,
    payload: Property.searchProperties(data),
  };
};